export var storageDisabled = false;
export var Storage80PercentMultiplier = 0.8;
export var Storage90PercentMultiplier = 0.9;
export var AMCTargetUrl = 'https://account.microsoft.com/services/microsoft365/renew?fref=Office-value-banner-renew';
export var ManageStorageOneDriveUrl = 'https://go.microsoft.com/fwlink/?linkid=2228772';
export var LoginHintParam = 'login_hint';
//# sourceMappingURL=constants.js.map